import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {Elink, FetchContactPersonsUrl, UpdateContactPersonsUrl,UpdateStorageContactPersonsUrl, For} from "../CommonComponents/Routes";
import Loader from "../CommonComponents/Loader";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";

export default (props = {}) => {
    const { mode: incomingMode, initialContactPersons = [], onHide, onUpdated } = props; // use default [] and ensure usage
    const mode = incomingMode || (For === 'storage' ? 'storage' : 'estimate');
    const [ContactPersons, setContactPersons] = useState({ list: {} });
    const [BodyState ,setBodyState] = useState("MINI-LOADING");
    const [newContactPersonTrack, setNewContactPersonTrack] = useState({ counter: -1, ids: [] });
    const [isChecked, setIsChecked] = useState(false);
    const [optinmsg, setOptinmsg] = useState('');
    const [privacyUrl, setPrivacyUrl] = useState('');
    const [termsUrl, setTermsUrl] = useState('');
    let RecordsController = useContext(RecordsManagementContext);
    let PageView = useContext(ViewMangementContext);
    // Derive company name based on mode (storage uses StorageAccount.CompanyName)
    const companyName = mode === 'storage'
        ? ((RecordsController.SP_PageDetails && RecordsController.SP_PageDetails.StorageAccount && RecordsController.SP_PageDetails.StorageAccount.CompanyName) || '')
        : ((RecordsController.CP_PageDetails && RecordsController.CP_PageDetails.ContactInformation && RecordsController.CP_PageDetails.ContactInformation.CompanyName) || '');

    // Normalization helper to ensure phone numbers is always an array
    const normalizePhoneNumbers = (numbers) => {
        if (numbers === undefined || numbers === null) return [''];
        if (Array.isArray(numbers)) return numbers.length ? numbers : [''];
        // If it's a single string/number, wrap it
        if (typeof numbers === 'string' || typeof numbers === 'number') return [String(numbers)];
        return [''];
    }

    useEffect(() => {
        const fetchOrInit = async () => {
            if (mode === 'storage') {
                const hasInitial = Array.isArray(initialContactPersons) && initialContactPersons.length > 0;
                let storageList = hasInitial ? initialContactPersons : [];
                if (!hasInitial && RecordsController.SP_PageDetails && Array.isArray(RecordsController.SP_PageDetails.ContactPersons)) storageList = RecordsController.SP_PageDetails.ContactPersons;
                const hash = {};
                let anySms = false;
                storageList.forEach((contact_person, idx) => {
                    const id = contact_person.Id || contact_person.id || `StorageContact-${idx}`;
                    const receiveSms = contact_person.ReceiveSms === true;
                    if (receiveSms) anySms = true;
                    hash[id] = {
                        Id: id,
                        FirstName: contact_person.FirstName || contact_person.Name || '',
                        LastName: contact_person.LastName || '',
                        Email: contact_person.Email || contact_person.Mail || '',
                        PhoneNumbers: Array.isArray(contact_person.PhoneNumbers) ? (contact_person.PhoneNumbers.length ? contact_person.PhoneNumbers : ['']) : [''],
                        ReceiveSms: receiveSms
                    };
                });
                setIsChecked(anySms);
                setContactPersons({ list: hash });
                setBodyState('CLIENT-INFO-FORM');
                return;
            }
                const response = await axios({method: 'post', url: FetchContactPersonsUrl, params: {estimate_key: Elink, For: For}});
                const Message = response.data.Message;
                if (Message && Message.Status === 'failed') {
                    window.location.reload();
                    return;
                }
                setBodyState('CLIENT-INFO-FORM');
                const hash = {};
                response.data.ContactPersons.forEach((contact_person) => {
                    const counter = newContactPersonTrack.counter + 1;
                    const ids = [...newContactPersonTrack.ids, contact_person.Id];
                    setNewContactPersonTrack({ counter, ids });
                    hash[contact_person.Id] = {
                        Id: contact_person.Id,
                        FirstName: contact_person.FirstName,
                        LastName: contact_person.LastName,
                        Email: contact_person.Email,
                        PhoneNumbers: contact_person.PhoneNumbers.length ? contact_person.PhoneNumbers : [''],
                        ReceiveSms: contact_person.ReceiveSms
                    };
                    setIsChecked(contact_person.ReceiveSms);
                });
                setContactPersons({ list: hash });
                setOptinmsg(response.data.OptInMsg || '');
                setPrivacyUrl(response.data.PrivacyPolicyUrl || '');
                setTermsUrl(response.data.TermsConditionUrl || '');
        };
        fetchOrInit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleInputChange = (e) => { //handle name,emails fields
        let newHash = ContactPersons
        let contact_person = newHash.list[e.target.id]
        contact_person[e.target.name] = e.target.value
        newHash.list[e.target.id] = contact_person
        setContactPersons({
            list: newHash.list
        });
    }

    const HandelPhoneNumberInputs = (e) => {//handle phone numbers
        let id = e.target.id.split(":")[0]
        let key = e.target.id.split(":")[1]
        let newHash = ContactPersons
        let contact_person = newHash.list[id]
        contact_person.PhoneNumbers[key] = e.target.value.replace(/\D/g, "");
        newHash.list[id] = contact_person
        setContactPersons({
            list: newHash.list
        });
    }


    const AddNewContactPerson = (counter) => { // add new contact person
        let count = newContactPersonTrack.counter
        let array = newContactPersonTrack.ids
        array.push("ContactPerson-" + counter)
        setNewContactPersonTrack({
            counter: count + 1,
            ids: array
        })
        let hash = ContactPersons.list
        hash["ContactPerson-" + counter] = {
            Id: "ContactPerson-" + counter,
            FirstName: '',
            LastName: '',
            Email: '',
            PhoneNumbers: ['']
        }
        setContactPersons({
            list: hash
        })
    }
    const AddPhnNumber = (id) => {
        let hash = ContactPersons.list
        let phone_numbers = hash[id]["PhoneNumbers"]
        phone_numbers.push(" ")
        hash[id]["PhoneNumbers"] = phone_numbers
        setContactPersons({
            list: hash
        });
    }

    const UpdateContactPersons = async (ContactPersonsList) => {
        let cookie = document.cookie.split('employee_id=')[1] //fetch that if current employee is admin or not
        let checkValidation =  await ValidateEmail() // check validations
        if (checkValidation !== undefined) return; // stop on validation error
        RecordsController.setContactInfoModal(false)//close the contact info modal
        axios({//request is send to the "update_contact_persons" function in "client-=portal_controller"
            method: 'post',
            url: mode !== 'storage' ? UpdateContactPersonsUrl : UpdateStorageContactPersonsUrl,
            params: {estimate_key: Elink, employee_key: cookie, contact_persons_list: ContactPersonsList, For: For}
        }).then((response) => {
            if (mode === 'storage') {
                const converted = Object.values(ContactPersonsList).map(cp => ({
                    FirstName: (cp.FirstName).trim(),
                    LastName: (cp.LastName).trim(),
                    PhoneNumbers: (cp.PhoneNumbers && cp.PhoneNumbers) || [],
                    Email: cp.Email || '',
                    FullName: `${(cp.FirstName).trim()} ${(cp.LastName).trim()}`.trim(),
                    ReceiveSms: cp.ReceiveSms === true
                }));
                if (typeof onUpdated === 'function') onUpdated(converted);
                if (RecordsController.SetSP_PageDetails) {
                    RecordsController.SetSP_PageDetails({
                        ...RecordsController.SP_PageDetails,
                        ContactPersons: converted
                    });
                }
                if (typeof onHide === 'function') onHide();
            }
                RecordsController.SetCP_PageDetails({
                    ...RecordsController.CP_PageDetails,
                    ContactInformation: {
                        ...RecordsController.CP_PageDetails.ContactInformation,
                        ContactPersons: response.data.ContactPersons
                    }
                })
                let Message = response.data.Message
                PageView.setAlertProperty({//shows the alert message
                    Message: Message.Text,
                    Type: Message.Type,
                    Show: true,
                    AutoHide: true
                })
        })
    };

    const Updatesmsconsent = async (receive_sms) => {
        // Enable SMS updates for both modes; in storage update local state only until full update
        setIsChecked(receive_sms);
        setContactPersons(prev => {
            const newList = { ...prev.list };
            Object.keys(newList).forEach(id => {
                newList[id] = { ...newList[id], ReceiveSms: receive_sms };
            });
            return { list: newList };
        });
        let cookie = document.cookie.split('employee_id=')[1];
        axios({
            method: 'post',
            url: mode !== 'storage' ? UpdateContactPersonsUrl : UpdateStorageContactPersonsUrl,
            params: {estimate_key: Elink, employee_key: cookie, receive_sms: receive_sms}
        }).then((response) => { //
        })
    }

    const removePhnNumber = (id) => { //remove the contact numbers
        let hash = ContactPersons.list
        let phone_numbers = hash[id.split(":")[0]].PhoneNumbers
        phone_numbers.splice(id.split(":")[1], 1)
        hash[id.split(":")[0]].PhoneNumbers = phone_numbers
        setContactPersons({
            list: hash
        });
    }
    const RemoveContactPerson = (id) => { //remove the contact persons
        let Counter = newContactPersonTrack.counter
        let array = newContactPersonTrack.ids
        array.pop(id)
        Counter = Counter - 1;
        setNewContactPersonTrack({
            counter: Counter,
            ids: array
        })
        let List = ContactPersons.list
        let ID = id
        delete List[ID]
        setContactPersons({
            list: List
        })
    }
    const RemoveContactPrnsBtn = (props) => { ////remove the contact person btn
        if (props.index === 0) {
            return ('')
        } else {
            return (
                <div className="btn btn-warning remove-person-btn" onClick={() => RemoveContactPerson(props.id)}>
                    Remove The Below Contact
                    Person</div>
            )
        }
    }

    const InputField = (props) => {//handle input fields
        let Name = props.Name
        let OnChange = Name === 'PhoneNumbers' ?  HandelPhoneNumberInputs : handleInputChange
        return (
            <input
                className={Name === 'Email' ? 'form-control email-field' : (Name === 'LastName' || Name === 'FirstName' ? 'form-control last-name-field' : 'form-control')}
                value={props.VALUE}
                onChange={OnChange}
                name={props.Name}
                key={props.INDEX}
                id={props.ID}
                disabled={props.Hide !== undefined && props.Hide !== 'false'}
            />
        )
    }

    const ValidateEmail =   () => { //check the validations
        let element = document.getElementsByClassName("email-field")
        let element2 = document.getElementsByClassName("last-name-field")
        let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        for ( let i = 0; i < element.length; i++) {
            element[i].setAttribute('style', 'border: 2px solid none');
            if (!reg.test(element[i]["value"]) && element[i]["value"] !== "") {
                element[i].setAttribute('style', 'border: 2px solid red');
                PageView.setAlertProperty({
                    Message: "Please enter a valid email address !...",
                    Type: "warning",
                    Show: true,
                    AutoHide: true
                })
                return false
            }
        }
        for ( let i = 0; i < element2.length; i++) {
            element2[i].setAttribute('style', 'border: 2px solid none');
            if (element2[i]["value"] === "") {
                element2[i].setAttribute('style', 'border: 2px solid red');
                PageView.setAlertProperty({
                    Message: "Field can't be empty..!",
                    Type: "warning",
                    Show: true,
                    AutoHide: true
                })
                return false
            }
        }
    }

    const ContactPersonInfo = (props) =>{
        return(
            <div  className="row align-items-center mb-3">
                <div className="col-4">
                    <label >{props.Type}</label>
                </div>
                <div className="col-8">
                    {InputField({
                        VALUE: `${props.InputValue}`,
                        Name: `${props.InputName}`, INDEX: `${props.key + "input1"}`, ID: `${props.PersonId}`,
                        ...(props.Hide !== undefined && { Hide: props.Hide })
                    })}
                </div>
            </div>
        )
    }

    let isEditName = RecordsController.CP_PageDetails && RecordsController.CP_PageDetails.editFields ? RecordsController.CP_PageDetails.editFields.name : true
    let PhnNumberType = [["Mobile Phone", 1], ["Business phone", 2], ["Home phone", 3], ["Fax", 4]]
    if(BodyState === 'MINI-LOADING') {
        return (
            <Loader For={'AJAX'} UniqueId={'4'}/>
        );
    } else {
        return (
            <div className="contact-info-form">
                {/* Conditional heading for storage vs estimate modes */}
                {mode === 'storage' && (
                    <div className="bill-to-header mb-2">
                        <h6 style={{fontWeight:700, marginBottom:'4px', color:'#000'}}>BILL TO:</h6>
                        {companyName && <h4 style={{fontSize:'14px', fontWeight:600, marginBottom:'8px'}}>{companyName}</h4>}
                    </div>
                )}
                {mode !== 'storage' && (
                    <div className="contact-info-header mb-2">
                        <h6 style={{fontWeight:600, marginBottom:'4px'}}>Contact Information</h6>
                        {companyName && <h4 style={{fontSize:'14px', fontWeight:600, marginBottom:'8px'}}>{companyName}</h4>}
                    </div>
                )}
                {/* Existing dynamic contact person forms */}
                {Object.keys(ContactPersons.list).map((id, key) => {
                    let ContactPerson = ContactPersons.list[id]
                    // Safely normalize before mapping
                    let phn_numbers = normalizePhoneNumbers(ContactPerson.PhoneNumbers)
                    return (
                        <div className='contact-form-wrap-info' key={key + "main_div"}>
                            <div key={key + "div1"}>
                                <RemoveContactPrnsBtn index={key} id={ContactPerson.Id}/>
                                <form key={key + "form"} className="form-horizontal form-info-wrapper">
                                    {ContactPersonInfo({
                                        InputValue: `${ContactPerson.FirstName}`,
                                        InputName: `FirstName`,
                                        Type: `First Name:`,
                                        key:`${key}`,
                                        PersonId: `${ContactPerson.Id}`,
                                        Hide: `${!isEditName}`
                                    })}
                                    {ContactPersonInfo({
                                        InputValue: `${ContactPerson.LastName}`,
                                        InputName: `LastName`,
                                        Type: `Last Name:`,
                                        key:`${key}`,
                                        PersonId: `${ContactPerson.Id}`,
                                        Hide: `${!isEditName}`
                                    })}
                                    {ContactPersonInfo({
                                        InputValue: `${ContactPerson.Email === null ? "" : ContactPerson.Email}`,
                                        InputName: `Email`,
                                        Type: `Email:`,
                                        key:`${key}`,
                                        PersonId: `${ContactPerson.Id}`
                                    })}

                                    {phn_numbers.map((phn_number, key_2) => {
                                        return (
                                            <div key={key + "div101"} className="row align-items-center mb-3" >
                                                <div key={key + "div102"} className="col-4">
                                                    <select className='form-control'
                                                            key={key_2 + key + "select"} >
                                                        {PhnNumberType.map((PhnType,index) =>{
                                                            return(
                                                                <option key={key_2 + key + index +"option1"}
                                                                        value={PhnType[1]}>{PhnType[0]}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                                <div key={key + "div103"} className="col-8 number-dropdoen-wp">
                                                    {InputField({
                                                        VALUE: `${phn_number}`,
                                                        Name: `PhoneNumbers`,
                                                        INDEX: `${key + "input25" + key_2}`,
                                                        ID: `${ContactPerson.Id + ":" + key_2}`
                                                    })}
                                                    <div className="btn-sm btn-danger"
                                                         onClick={() => removePhnNumber(ContactPerson.Id +
                                                             ":" + key_2)}>X
                                                    </div>
                                                </div>

                                            </div>
                                        )
                                    })}

                                </form>
                                <button className="btn btn-primary contact-btns-bg"
                                        onClick={() => AddPhnNumber(ContactPerson.Id)}>Add A Phone
                                </button>
                            </div>
                        </div>
                    )
                })}
                <button className="btn btn-dark contact-btns-bg d-block text-center"
                        onClick={() => AddNewContactPerson(newContactPersonTrack.counter)}>Add
                    A Contact Person
                </button>
                <div>
                <span><input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => Updatesmsconsent(e.target.checked)}
                /> {optinmsg}
                </span></div>
                <button className="btn btn-warning contact-btns-bg bg-clr-info"
                        onClick={() => UpdateContactPersons(ContactPersons.list)} >Update
                </button>
                <div className="contact-legal-links">
                    {privacyUrl && (
                        <a
                            href={privacyUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="legal-link"
                        >
                            Privacy Policy
                        </a>
                    )}
                    {(privacyUrl && termsUrl) && <span className="legal-separator">|</span>}
                    {termsUrl && (
                        <a
                            href={termsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="legal-link"
                        >
                            Terms of Service
                        </a>
                    )}
                </div>
            </div>
        )
    }
}
